"use client";

import { SignInButton } from "@clerk/react";
import { Button, type SxProps, type Theme } from "@mui/material";
import { type FC } from "react";

import { useAuthRedirectUrl } from "~/feature/auth/hooks/useAuthRedirectUrl";

interface IAppSignInButtonProps {
  name?: string;
  sx?: SxProps<Theme>;
}

export const AppSignInButton: FC<IAppSignInButtonProps> = ({
  name = "Log In",
  sx,
}) => {
  const redirectUrl = useAuthRedirectUrl();

  return (
    <SignInButton mode="modal" forceRedirectUrl={redirectUrl}>
      <Button size="small" variant="outlined" color="primary" sx={sx}>
        {name}
      </Button>
    </SignInButton>
  );
};
